import {GatewayStatus} from "@/api";
import {TableCell, TableRow} from "@mui/material";
import {Link} from "../widgets";
import {CompactNumber} from "@/components/domain-status/widgets";
import FormattedRegistrationTime from "@/components/FormattedRegistrationTime";

type Props = {
    domainId: number;
    gateway: GatewayStatus;
};

export default ({domainId, gateway}: Props) => (
    <TableRow>
        <TableCell>
            <Link to={`/domains/${domainId}/gateways/gateways/${gateway.gatewayId}`}>
                <CompactNumber e164={gateway.e164} shortNumber={gateway.shortNumber} />
            </Link>
        </TableCell>
        <TableCell>{gateway.displayName}</TableCell>
        <TableCell>{gateway.ipAddress}</TableCell>
        <TableCell>
            <FormattedRegistrationTime
                registrationTime={gateway.registrationTime}
                expirationTime={gateway.registrationExpireTime}
                clientInfo={gateway.clientInfo}
            />
        </TableCell>
    </TableRow>
);
